import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function categoryReducer(state = initialState.categories, action) {
  switch (action.type) {
    case types.LOAD_CATEGORY_DATA_SUCCESS:
        return action.categories;
    default:
        return state;
  }  
}
